module.exports = __webpack_public_path__ + "assets/15d8a745a8eb757a5775bb289ac4d6fc.png";